export const white = '#FFF'
export const black = '#000'

export const green = {
  500: '#00D110',
}

export const purple = {
  200: '#bd7cfe',
  400: '#ab47bc',
  700: '#7b1fa2',
}

export const red = {
  100: '#C1C1FF',
  200: '#7575FF',
  500: '#9090FF',
}

export const blue = {
  100: '#E8F0FF',
  900: '#3478FE'
}

export const grey = {
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575', 
  700: '#616161',
  800: '#424242',
  // 900: '#212121',
  900: '#0a5eff'
}

export const bg = '#000000';

export const teal = {
  200: '#64ffda'
}

// https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
// module.exports = {
//   // 'primary-color': '#ffaaff',
//   // 'primary-color': '#439FEF',
//   'primary-color': '#a843fd',
//   // 'secondary-color':'#439fef',
//   'secondary-color':'#9833ed',
//   'red':'#ff665f',
//   'dark':'#444',
//   // 'green':'#45b35f',
//   'green':'#4dc677',
//   'menu-bg':'#f5f5f5',
//   'menu-dark-bg':'#f5f5f5f',
//   'menu-dark-color':'#f5f5f5',
//   'card-actions-background': '#05f8fa',
//   'input-height-lg':'50px',
//   'success-color':'#439FEF'
//   // 'ant-progress-status-success':'#439FEF',
//   // 'ant-progress-bg':'#439FEF',
//   // 'ant-progress-status-success':{'background-color':'transparent'},
//   // 'ant-progress-bg':{'background-color':'#439F00'},
// }; 
